import {DeployInfo} from "@khan/shared-core";
import {parseUrl} from "@khan/urls";

import {isAPIURL} from "./is-api-url.ts";

/**
 * Add anti-cache parameter in url by default for all api calls, unless
 * they have the default 'v' parameter of cacheable in api/decorators.py or
 * if the cache parameter is already set.
 *
 * Because it's useful for debugging in its own right, we have the
 * anti-cache param include the static-content version of this js.
 * (This lets us know how old the js was that made this xhr call.)
 *
 * @param url the URL of the request
 * @returns the potentially-modified URL
 */
export const addCacheParam = (url: string): string => {
    // We only process URLs that are going to an API endpoint
    if (!isAPIURL(url)) {
        return url;
    }

    const cacheURL = parseUrl(url);

    // Also, if there is a v parameter or fastly_cacheable parameter then we
    // want the request to be cached, so we leave the URL alone.
    if (
        cacheURL.searchParams.has("v") ||
        cacheURL.searchParams.has("fastly_cacheable")
    ) {
        return url;
    }

    // We use a combination of the current version and the date (this both
    // breaks the cache and makes it easier to track what version of code
    // users are using)
    cacheURL.searchParams.set("_", `${DeployInfo.staticVersion}_${Date.now()}`);

    return cacheURL.href;
};
